import { sessionStorageKeyConstants } from '../../constants/session-storage-key-constants'
import { getHeaders } from '../axios/axios-helpers'
import HttpClient from '../axios/http-client'

export async function getItemTagSerialNumbers(requestData) {
  const url = `/itemTagSerials?itemNumber=${requestData.itemNumber}&tag=${requestData.tag}&lot=${requestData.lot}&location=${requestData.location}&itemCode=${requestData.itemCode}`
  const idToken = sessionStorage.getItem(sessionStorageKeyConstants.ID_TOKEN)
  const headers = getHeaders(idToken)
  const httpClient = new HttpClient(headers)
  return httpClient.inventoryInstance().get(url)
}
